// extracted by mini-css-extract-plugin
module.exports = {"Image":"styles_Image__oX_Nv","placeholder":"styles_placeholder__pr_8B","asPlaceholder":"styles_asPlaceholder__aImMd"};